export const athletesReducer = (
	state = {
		list: undefined,
		count: 0,
		athletesData: [],
		athletesDetails: undefined,
		detail: undefined,
		athletesDropdownData: []
	},
	action
) => {
	switch (action.type) {
		case "ATHLETES_LIST_SUCCESS":
		case "ATHLETES_SEARCH_SUCCESS":
			console.log("action.payload", action.payload);
			return {
				...state,
				list: action.payload.list,
				count: action.payload.count,
				athletesData: action.payload.athletesData,
			};
		case "ATHLETES_DETAILS":
			return {
				...state,
				athletesDetails: action.payload,
			};
		case "ATHLETES_DROPDOWN_LIST_SUCCESS":
			return {
				...state,
				athletesDropdownData: action.payload?.page == 1 ? action?.payload?.list : [...state?.athletesDropdownData, ...action?.payload?.list],
			};

		case "ATHLETES_TOGGLE_SUCCESS":
			return {
				...state,
				athletesDetails: { ...state?.athletesDetails, isActive: !state?.athletesDetails?.isActive },
			};
		case "ATHLETES_SEARCH_CLEAR":
			return {
				...state,
				list: undefined,
				count: 0,
			};
		default:
			return state;
	}
};
